import { Button, Tooltip, Typography } from "@callcenter/design-system"
import type { ReactNode } from "react"
import { is } from "@callcenter/helpers"

import { Logo } from "../logo"

import styles from "./blocking-overlay.module.pcss"

type BlockingOverlayProps = {
  title: string
  description: string | ReactNode
  primaryButton: {
    text: string
    onClick: () => void
    isLoading?: boolean
    isDisabled?: boolean
    tooltip?: string
  }
  secondaryButton?: {
    text: string
    onClick: () => void
    isDisabled?: boolean
  }
  footer?: ReactNode
}

export const BlockingOverlay = ({
  title,
  description,
  primaryButton,
  secondaryButton,
  footer
}: BlockingOverlayProps) => (
  <div className={styles.wrapper}>
    <Logo />
    <div className={styles.card}>
      <Typography.Heading3>{title}</Typography.Heading3>
      {is.string(description) ? <Typography.Body2>{description}</Typography.Body2> : description}

      <div className={styles.buttonsGroup}>
        {secondaryButton && (
          <Button kind="outline" onClick={secondaryButton.onClick} isDisabled={secondaryButton.isDisabled}>
            {secondaryButton.text}
          </Button>
        )}
        <Tooltip title={primaryButton.tooltip} isVisibleDisabled={!primaryButton.tooltip}>
          <Button
            onClick={primaryButton.onClick}
            isDisabled={primaryButton.isDisabled}
            isLoading={primaryButton.isLoading}
          >
            {primaryButton.text}
          </Button>
        </Tooltip>
      </div>
    </div>
    {footer && <div className={styles.footer}>{footer}</div>}
  </div>
)
